import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/MainPage/Hero";
import ChargesScreen from "../components/MainPage/ChargesScreen";

const Layout = ({ children }) => {
  return (
    <div >
        <div  className="bg-cover"
            style={{ backgroundImage: "url('back-photo.jpg')"}} >
        <Navbar />
        <Hero />
        </div>
        <main>{children}</main>
        <Footer />
        
    </div>
  );
};

export default Layout;
